export function loadTextFile(url) {
    return fetch(url).then(response => response.text());
}
